import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../../library/src/resources/icons/User_cicrle.png'


const _hoisted_1 = { class: "profile-view flex-center" }
const _hoisted_2 = { class: "profile-title flex-center" }
const _hoisted_3 = {
  key: 0,
  class: "header-2"
}
const _hoisted_4 = {
  key: 1,
  class: "header-2"
}
const _hoisted_5 = {
  key: 2,
  class: "subtitle"
}
const _hoisted_6 = {
  key: 3,
  class: "subtitle"
}
const _hoisted_7 = { class: "profile-image" }
const _hoisted_8 = {
  key: 0,
  class: "progress-container"
}
const _hoisted_9 = { class: "progress-value" }
const _hoisted_10 = {
  key: 2,
  class: "placeholder-image",
  src: _imports_0
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "uploaded-image" }, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "profile-btn btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.pictureUploaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "You look great!"))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "Upload a Picture")),
      ($setup.pictureUploaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Here's what you uploaded"))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, "Upload a profile picture so people know its you?"))
    ]),
    _createElementVNode("div", _hoisted_7, [
      ($setup.uploadValue != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.uploadValue) + "%", 1 /* TEXT */)
          ]))
        : ($setup.pictureUploaded)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "placeholder-image",
              style: _normalizeStyle(`background:url(${$setup.imageURL}); background-size: cover; background-position:center;`)
            }, null, 4 /* STYLE */))
          : (_openBlock(), _createElementBlock("img", _hoisted_10)),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("input", {
        type: "file",
        ref: "fileInput",
        accept: "image/*",
        name: "image",
        id: "file",
        style: {"display":"none"},
        onChange: $setup.uploadFile
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
      _createElementVNode("button", {
        class: "primary upload",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fileInput!.click()))
      }, "Upload a Picture"),
      _createElementVNode("button", {
        class: "borderless",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('close')))
      }, "Back")
    ])
  ]))
}